import { concat } from 'ramda';
import timsApi from './timsApi';

const getUrl = concat('tims/');

const timsEndpoints = timsApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getTerminalAlerts: query({
      query: ({ dateFilter, terminalId }) => ({
        params: { dateFilter, terminalId },
        url: getUrl('GetTerminalAlerts'),
      }),
    }),
    getTerminalAlertsCount: query({
      query: () => ({
        url: getUrl('GetTerminalAlertsCount'),
      }),
    }),
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const { useGetTerminalAlertsQuery, useGetTerminalAlertsCountQuery } = timsEndpoints;
